import { render, staticRenderFns } from "./ChipWeekState.vue?vue&type=template&id=0e9777b0&"
import script from "./ChipWeekState.vue?vue&type=script&lang=ts&"
export * from "./ChipWeekState.vue?vue&type=script&lang=ts&"
import style0 from "./ChipWeekState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
